<template>
    <el-dialog :visible.sync="openDialog" custom-class="enquiry-detail-dislog" width="calc(100% - 20px)" top="20px" :title="title" :close-on-click-modal="false">
        <div class="enquiry-detail-wrap">
            <el-table :data="tableData" border size="mini" :row-class-name="tableRowClassName" :header-cell-style="headerCellStyle" :height="isEdit?PAGESIZE.h-140:PAGESIZE.h-90" v-loading="tableLoading">
                <el-table-column prop="rowNo" label="行号" width="50px" fixed="left"> </el-table-column>
              <!--  <el-table-column prop="wzCode" label="物料编码" :show-overflow-tooltip="true"  fixed="left"></el-table-column>  -->
                <!-- <el-table-column prop="qgdh" label="请购单号" :show-overflow-tooltip="true"  fixed="left"></el-table-column> -->
                <el-table-column prop="wzName" label="物料名称" :show-overflow-tooltip="true" fixed="left"></el-table-column>
              <!--  <el-table-column prop="sspace" label="规格" :show-overflow-tooltip="true" width="150px" fixed="left"></el-table-column>
              <el-table-column prop="wzModel" label="型号" :show-overflow-tooltip="true" ></el-table-column>
              <el-table-column prop="figueNumber" label="图号" :show-overflow-tooltip="true" ></el-table-column>
              -->
              <el-table-column prop="unit" label="计量单位" :show-overflow-tooltip="true" width="50px" ></el-table-column>
              <el-table-column prop="xjnum" label="询价数量" :show-overflow-tooltip="true" ></el-table-column>
              <el-table-column prop="xqDate" label="需求日期" :show-overflow-tooltip="true" ></el-table-column>
              <el-table-column prop="bcExplain" label="行备注" :show-overflow-tooltip="true" ></el-table-column>
              <el-table-column label="附件" width="95">
                  <template slot-scope="scope">
                      <el-tag v-if="scope.row.src==undefined && scope.row.masterRow" type="info">无附件
                      </el-tag>
                      <el-link v-if="scope.row.src && scope.row.masterRow" :underline="false" :href="baseURL+scope.row.src" target="_blank">
                          <el-tag type="success">查看附件</el-tag>
                      </el-link>
                  </template>
              </el-table-column>
              <el-table-column prop="gysName" class-name="gys-col gys-name-col" label="供应商" :show-overflow-tooltip="true" min-width="120px">
                  <template slot-scope="scope">
                      <span>{{  scope.row.gysName == -999?'***':scope.row.gysName }}</span>
                  </template>
              </el-table-column>
              <!-- 报价数量 -->
                <el-table-column prop="num" v-if="orderInfo.orderState != 1" class-name="gys-col" label="报价数量">
                    <template slot-scope="scope">
                        <el-input  v-if="isEdit" size="mini" v-model="scope.row.num" @blur="countMoney(scope.row)" @keyup.native="tenderNumChange(scope.row,'num')" class="table-edit-input"/>
                        <span v-if="!isEdit">{{  scope.row.num == -999?'***':scope.row.num }}</span>
                    </template>
                </el-table-column>
                <!-- 含税单价 -->
                <el-table-column prop="price" width="120px" v-if="orderInfo.orderState != 1" class-name="gys-col" label=""  >
                    <template slot="header" slot-scope="scope">
                        <div><span v-if="isEdit" style="color:red;margin-right:5px">*</span>含税单价</div>
                    </template>
                    <template slot-scope="scope">
                        <el-input  v-if="isEdit" size="mini" :disabled="scope.row.isFq" v-model="scope.row.price" @blur="countMoney(scope.row)" @keyup.native="fixedPriceChange(scope.row,'price')" class="table-edit-input">
                            <template slot="append">元</template>
                        </el-input>
                        <!-- <span v-if="!isEdit">{{  scope.row.price }}</span> -->
                        <span v-if="!isEdit">{{  scope.row.price && scope.row.price == -999 ? '***' : scope.row.price }}</span>
                    </template>
                </el-table-column>
                <!-- 含税金额 -->
                <el-table-column prop="amount" width="120px" v-if="orderInfo.orderState != 1" class-name="gys-col" label="含税金额" :show-overflow-tooltip="true" >
                    <template slot="header" slot-scope="scope">
                        <div><span v-if="isEdit" style="color:red;margin-right:5px">*</span>含税金额</div>
                    </template>
                    <template slot-scope="scope">
                        <el-input  v-if="isEdit" size="mini" :disabled="scope.row.isFq" v-model="scope.row.amount" readonly class="table-edit-input">
                            <template slot="append">元</template>
                        </el-input>
                        <span v-if="!isEdit">{{  scope.row.amount && scope.row.amount == -999?'***':scope.row.amount }}</span>
                    </template>
                </el-table-column>
                <!-- 税率
                <el-table-column prop="taxRate" width="70px" v-if="orderInfo.orderState != 1" class-name="gys-col" label="税率">
                    <template slot="header" slot-scope="scope">
                        <div><span v-if="isEdit" style="color:red;margin-right:5px">*</span>税率</div>
                    </template>
                    <template slot-scope="scope">
                        <el-input  v-if="isEdit" size="mini" :disabled="scope.row.isFq" @keyup.native="fixedPriceChange(scope.row,'taxRate')" v-model="scope.row.taxRate" class="table-edit-input">
                            <template slot="append">%</template>
                        </el-input>
                        <span v-if="!isEdit && (scope.row.taxRate || scope.row.taxRate == '0' ) && scope.row.taxRate != -999">{{scope.row.taxRate}}%</span>
                        <span v-if="!isEdit && scope.row.taxRate == -999">***</span>
                    </template>
                </el-table-column>
              -->
                <el-table-column prop="isFq" width="50px"  v-if="orderInfo.orderState != 1" class-name="gys-col" label="是否放弃" align="center">
                    <template slot-scope="scope">
                        <el-switch
                            size="mini"
                            v-if="isEdit"
                            v-model="scope.row.isFq"
                            active-color="#ff4949"
                            inactive-color="#999">
                        </el-switch>
                        <span v-if="!isEdit && scope.row.isFq == '-999'">***</span>
                        <span v-if="!isEdit && scope.row.isFq != '-999' &&scope.row.isFq != '-1' && scope.row.gysName">{{  scope.row.isFq?'是':'否' }}</span>
                        <span v-if="(!isEdit && scope.row.isFq != '-999' && scope.row.isFq == '-1') || !scope.row.gysName"></span>
                    </template>
                </el-table-column>
                <el-table-column prop="ghZq" width="70px"  v-if="orderInfo.orderState != 1" class-name="gys-col" label="">
                    <template slot="header" slot-scope="scope">
                        <div><span v-if="isEdit" style="color:red;margin-right:5px">*</span>供货周期(天)</div>
                    </template>
                    <template slot-scope="scope">
                        <el-input  v-if="isEdit" size="mini" :disabled="scope.row.isFq" v-model="scope.row.ghZq" @keyup.native="tenderNumChange(scope.row,'ghZq')" class="table-edit-input"/>
                        <span v-if="!isEdit">{{  scope.row.ghZq=='-999'?'***':scope.row.ghZq }}</span>
                    </template>
                </el-table-column>
              <!--
                <el-table-column prop="bjExplain" width="100px" v-if="orderInfo.orderState != 1" class-name="gys-col" label="付款方式">
                    <template slot-scope="scope">
                        <el-select
                            v-if="isEdit"
                            size="mini"
                            :disabled="scope.row.isFq"
                            v-model="scope.row.bjExplain"
                            style="width: 100%"
                            clearable
                            placeholder="请选择付款方式"
                        >
                                <el-option label="复验合格后按合同约定付款" value="复验合格后按合同约定付款"></el-option>
                                <el-option label="款到发货" value="款到发货"></el-option>
                                <el-option label="其他" value="其他"></el-option>
                        </el-select>
                        <span v-if="!isEdit">{{  scope.row.bjExplain=='-999'?'***':scope.row.bjExplain }}</span>
                    </template>
                </el-table-column>
              -->
                <el-table-column prop="effectivePeriod" width="120px"  v-if="orderInfo.orderState != 1" class-name="gys-col" label="">
                    <template slot="header" slot-scope="scope">
                        <div><span v-if="isEdit" style="color:red;margin-right:5px">*</span>报价有效期(天)</div>
                    </template>
                    <template slot-scope="scope">
                        <el-date-picker
                            v-if="isEdit"
                            :disabled="scope.row.isFq"
                            v-model="scope.row.effectivePeriod"
                            value-format="yyyy-MM-dd"
                            class="table-edit-inputDate"
                            type="date"
                            size="mini"
                            :picker-options="{
                                disabledDate(time) {
                                    return time.getTime() < new Date(new Date().setHours(0, 0, 0, 0)).getTime();
                                },
                            }"
                            placeholder="选择日期">
                        </el-date-picker>
                        <span v-if="!isEdit">{{  scope.row.effectivePeriod=='-999'?'***':scope.row.effectivePeriod }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="bjwlmc" width="100px" v-if="orderInfo.orderState != 1" class-name="gys-col" label="报价物料名称">
                    <template slot-scope="scope">
                        <el-input  v-if="isEdit" size="mini" :disabled="scope.row.isFq" v-model="scope.row.bjwlmc" class="table-edit-input"/>
                        <span v-if="!isEdit">{{  scope.row.bjwlmc=='-999'?'***':scope.row.bjwlmc }}</span>
                    </template>
                </el-table-column>

                <!-- 报价规格 sspace-->
              <!--
               <el-table-column prop="bjgg" width="180px" v-if="orderInfo.orderState != 1" class-name="gys-col" label="报价规格">
                   <template slot-scope="scope">
                       <el-input  v-if="isEdit" size="mini" :disabled="scope.row.isFq" v-model="scope.row.bjgg" class="table-edit-input"/>
                       <span v-if="!isEdit">{{  scope.row.bjgg=='-999'?'***':scope.row.bjgg }}</span>
                   </template>
               </el-table-column>
             -->
                <!-- 报价型号-->
              <!--
                <el-table-column prop="bjxh" width="180px" v-if="orderInfo.orderState != 1" class-name="gys-col" label="报价型号">
                    <template slot-scope="scope">
                        <el-input  v-if="isEdit" size="mini" :disabled="scope.row.isFq" v-model="scope.row.bjxh" class="table-edit-input"/>
                        <span v-if="!isEdit">{{  scope.row.bjxh=='-999'?'***':scope.row.bjxh }}</span>
                    </template>
                </el-table-column>
              -->
                <!-- 报价图号-->
              <!--
                <el-table-column prop="bjth" width="180px" v-if="orderInfo.orderState != 1" class-name="gys-col" label="报价图号">
                    <template slot-scope="scope">
                        <el-input  v-if="isEdit" size="mini" :disabled="scope.row.isFq" v-model="scope.row.bjth" class="table-edit-input"/>
                        <span v-if="!isEdit">{{  scope.row.bjth=='-999'?'***':scope.row.bjth }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="minCgl" width="100px" v-if="orderInfo.orderState != 1" class-name="gys-col" label="最小采购量">
                    <template slot-scope="scope">
                        <el-input  v-if="isEdit" size="mini" :disabled="scope.row.isFq" v-model="scope.row.minCgl" @keyup.native="fixedPriceChange(scope.row,'minCgl')" class="table-edit-input"/>
                        <span v-if="!isEdit">{{scope.row.minCgl=== -999?'***' : scope.row.minCgl }}</span>
                    </template>
                </el-table-column>
              -->

              <!-- 运费模式 -->
              <el-table-column prop="manufacture" width="100px"  v-if="orderInfo.orderState != 1" class-name="gys-col">
                <template slot="header" slot-scope="scope">
                  <div><span v-if="isEdit" style="color:red;margin-right:5px">*</span>运费模式</div>
                </template>
                <template slot-scope="scope">
                  <el-select
                      v-if="isEdit && makerInfo"
                      size="mini"
                      :disabled="scope.row.isFq"
                      v-model="scope.row.manufacture"
                      style="width: 100%"
                      clearable
                      placeholder="请选择运费模式"
                  >
                    <el-option v-for="mitem in makerInfo.list" :key="mitem.id" :label="mitem.name" :value="mitem.name"></el-option>
                  </el-select>
                  <span v-if="!isEdit">{{  scope.row.manufacture=='-999'?'***':scope.row.manufacture }}</span>
                </template>
              </el-table-column>
                <el-table-column prop="remark" width="100px" v-if="orderInfo.orderState != 1" class-name="gys-col" label="提货油库">
                    <template slot-scope="scope">
                        <el-input
                            type="textarea"
                            v-if="isEdit" size="mini"
                            v-model="scope.row.remark"
                            :disabled="scope.row.isFq"
                            :rows="1"
                            class="table-edit-input">
                        </el-input>
                        <span v-if="!isEdit">{{ scope.row.remark=='-999'?'***':scope.row.remark }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="gysSrc" width="100px" v-if="orderInfo.orderState != 1" class-name="gys-col" label="供应商附件">
                    <template slot-scope="scope">
                        <div v-if="isEdit" @click="clickUpload(scope.row)">
                            <el-upload class="upload-demo"
                                :action="upload()"
                                :disabled="scope.row.isFq"
                                :show-file-list="false"
                                accept=".xls,.xlsx,.doc,.docx,.pdf,application/msword"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload" :headers="{'Authentication':token()}">
                                <el-input style="width:100%"  size="mini"  v-model="scope.row.gysSrc" placeholder="点击文本框上传" readonly slot="trigger" />
                            </el-upload>
                        </div>
                        <div v-if="!isEdit">
                            <el-tag v-if="!scope.row.gysSrc" type="info">无附件 </el-tag>
                            <el-link v-else :underline="false" :href="baseURL+scope.row.gysSrc" target="_blank">
                                <el-tag type="success">查看附件</el-tag>
                            </el-link>
                        </div>
                    </template>
                </el-table-column>


             <!--   <el-table-column prop="a13" v-if="orderInfo.orderState != 1" class-name="gys-col" label="历史最低报价"></el-table-column> -->
                <el-table-column width="50px" v-if="isTender" prop="isTender" class-name="gys-col" label="是否中标">
                    <template slot-scope="scope">
                        <el-switch
                            size="mini"
                            v-if="!isShowTender && scope.row.gysName"
                            v-model="scope.row.isTender"
                            active-color="#67c23a"
                            inactive-color="#999">
                        </el-switch>
                        <span v-if="isShowTender && scope.row.gysName">{{  scope.row.isTender?'是':'否' }}</span>
                    </template>
                </el-table-column>
                <el-table-column v-if="isTender" prop="tenderNum" class-name="gys-col" label="中标数量">
                    <template slot-scope="scope">
                        <el-input  v-if="!isShowTender && scope.row.gysName" size="mini" v-model="scope.row.tenderNum" @keyup.native="tenderNumChange(scope.row,'tenderNum')" class="table-edit-input"/>
                        <span v-if="isShowTender && scope.row.gysName">{{  scope.row.tenderNum }}</span>
                    </template>
                </el-table-column>


                <el-table-column width="50px" v-if="checkRole('gys_role') && orderInfo.gysOrderState>=4" prop="isTender" class-name="gys-col" label="是否中标">
                    <template slot-scope="scope">
                        <span v-if="scope.row.gysName && orderInfo.orderState>3" style="color:#ff9811">{{  scope.row.isTender?'是':'否' }}</span>
                    </template>
                </el-table-column>

                <el-table-column v-if="checkRole('gys_role') && orderInfo.gysOrderState>=4" prop="zbjg" class-name="gys-col" label="中标价格">
                    <template slot-scope="scope">
                        <span v-if="scope.row.gysName && orderInfo.orderState>3" style="color:#ff9811">{{  scope.row.zbjg }}</span>
                    </template>
                </el-table-column>
              <el-table-column v-if="checkRole('gys_role') && orderInfo.gysOrderState>=4" prop="tenderNum" class-name="gys-col" label="中标数量">
                <template slot-scope="scope">
                  <span v-if="scope.row.gysName && orderInfo.orderState>3" style="color:#ff9811">{{  scope.row.tenderNum }}</span>
                </template>
              </el-table-column>
            </el-table>
        </div>
        <span slot="footer" class="dialog-footer" v-if="isEdit || isTender">
            <el-button @click="openDialog = false" :disabled="tableLoading" size="small">取 消</el-button>
            <el-button type="primary" :disabled="tableLoading" @click="saveInfo(false)" v-if="isEdit" size="small">暂存</el-button>
            <el-button type="primary" :disabled="tableLoading" @click="saveInfo(true)" v-if="isEdit" size="small">保存</el-button>
            <el-button type="primary" :disabled="tableLoading" @click="saveTender" v-if="isTender&&!isShowTender" size="small">确认定标</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { getInquiryRoundDetail,updateBjList,getOrder,dingbiaoOrder } from '@/api/srm/inquiryDetail.js'
import { Decimal } from '@/utils/decimal.js'
import { decimalUtil } from '@/utils/index.js'
export default {
    props:['orderInfo'],
    data(){
        return {
            openDialog:false,
            tableLoading:false,
            title:'',
            tableData:[],
            isEdit:false,   // 是否填写状态
            uploadRow:null,
            isTender:false, // 是否定标编辑
            isShowTender:false, //是否只是展示定标数据
        }
    },
    methods:{
        // 计算金额
        countMoney(row){
            if(row.num && row.price){
                row.amount = row.num*row.price
            }else{
                row.amount = ''
            }
        },
        tableRowClassName({row, rowIndex}) {
            if (row.masterRow) {    // 物料行
                return 'goods-row';
            } else {
                return 'gys-row';
            }
        },
        // 打开弹框 showTender 1 编辑定标  2 查看定标
        showDialog(row,type,title,isTender,showTender){
            this.isEdit=type;
            this.title=title;
            this.isTender = isTender || false;
            this.isShowTender = showTender==2?true:false;
            this.openDialog=true;
            this.tableLoading=true;
            this.$nextTick(() => {
                if(isTender){
                    this.getTenderDetailTable(this.orderInfo,()=>{
                        this.$nextTick(()=>{
                            this.tableLoading=false;
                        })
                    })
                }else{
                    this.getDetailTable(row,()=>{
                        this.$nextTick(()=>{
                            this.tableLoading=false;
                        })
                    })
                }
            })
        },
        // 定标询价明细数据处理
        getTenderDetailTable(row,callback){
            getOrder({id:row.id}).then(({data: res})=>{
                if(res.code == 0){
                    this.tableDataBuild(res,(tableList)=>{
                        this.tableData = tableList;
                        if(callback){
                            callback()
                        }
                    })
                }
            })
        },
        // 询价明细数据处理
        getDetailTable(row,callback){
            getInquiryRoundDetail({id:row.id}).then(({data: res})=>{
                if(res.code == 0){
                    this.tableDataBuild(res,(tableList)=>{
                        this.tableData = tableList;
                        if(callback){
                            callback()
                        }
                    })
                }
            })
        },
        // 数据行渲染
        tableDataBuild(res,callback){
            let tableList = [];
            let goods = res.data || []; // 物料
            goods.forEach((good,gindex)=>{
                let rowObj = {
                    index:0,            // 行索引
                    id:undefined,       // id
                    masterRow:false,    // 是否商品行
                    rowNo:undefined,    // 行号
                    wzCode:undefined,   // 物料编码
                    qgdh:undefined,     // 请购编码
                    wzName:undefined,   // 物料名称
                    sspace:undefined,   // 规格
                    wzModel:undefined,  // 型号
                    // paramPz:undefined,  // 参数配置
                    unit:undefined,     // 计量单位
                    xjnum:undefined,      // 询价数量
                    xqDate:undefined,   // 需求日期
                    // fixedPrice:undefined,   // 限价
                    bcExplain:undefined,   // 行备注
                    isXqYp:undefined,   // 需要样品
                    src:undefined,   // 附件

                    gysName:undefined,      // 供应商

                    price:'',                   // 单价
                    amount:'',
                    taxRate:'',
                    isFq:false,                 // 是否放弃
                    manufacture:'',             // 制造厂商
                    ghZq:'',                    // 供货周期
                    bjExplain:'',               // 报价说明
                    effectivePeriod:'',               // 报价有效期天
                    minCgl:'',                 // 最小采购量
                    remark:'',                 // 特殊备注
                    gysSrc:'',                 // 供应商附件
                };
                if(this.isTender){  // 定标状态
                    rowObj['isTender'] = false;
                    rowObj['tenderNum'] = '';
                }
                let gysListAll = good.gysInfoList || [];
                // 处理当前商品不同供应商上价格从高到低排序
                //根据价格 从小到大排序
                let hasInfoList = [],noInfoList = [];
                gysListAll.forEach((hitem) => {
                    if(hitem.inquiryDetailUser){
                        hasInfoList.push(hitem)
                    }else{
                        noInfoList.push(hitem)
                    }
                })
                function sortPrice(a, b) {
                    let ap = a.inquiryDetailUser.price || 0;
                    let bp = b.inquiryDetailUser.price || 0;
                    return ap - bp;
                }
                hasInfoList.sort(sortPrice);
                let gysList = [...hasInfoList,...noInfoList];
                if(gysList.length>0){
                    gysList.forEach((gys,index)=>{
                        let curObj = {};
                        let bjinfo = gys.inquiryDetailUser || {};
                        let isSubmitBj = gys.inquiryDetailUser?true:false;   // 是否提交报价
                        let rowGys = {
                            isSubmitBj,
                            gysName:gys.supplierInfo.name,  // 供应商名称
                            backId:bjinfo.id,                   //
                            orderId:bjinfo.orderId,                   //
                            detailId:bjinfo.detailId,                   //
                            price:bjinfo.price,                                 // 单价
                            amount:bjinfo.amount,                                 // 总金额
                            taxRate:bjinfo.taxRate,                                 // 税率
                            manufacture:bjinfo.manufacture,             // 制造厂商
                            ghZq:bjinfo.ghZq,                    // 供货周期
                            bjExplain:bjinfo.bjExplain,               // 报价说明
                            effectivePeriod:bjinfo.effectivePeriod,               // 报价说明
                            bjwlmc:isSubmitBj?bjinfo.bjwlmc||good.commodityName:'',      //报价物料名称
                            bjgg:isSubmitBj?bjinfo.bjgg||good.commoditySspace:'',      //报价规格
                            bjxh:isSubmitBj?bjinfo.bjxh||good.commodityModel:'',      //报价型号
                            bjth:isSubmitBj?bjinfo.bjth||good.commodity.figueNumber:'',             //报价图号
                            num:isSubmitBj?bjinfo.num||good.inquiryDetail.num:'',             //报价数量
                            minCgl:bjinfo.minCgl,                 // 最小采购量
                            remark:bjinfo.remark,                 // 特殊备注
                            gysSrc:bjinfo.gysSrc,                 // 供应商附件
                            isTender:bjinfo.status==2,                 // 是否中标
                            tenderNum:bjinfo.zbsl,                 // 中标数量
                        }
                        if(this.checkRole('gys_role')){
                            rowGys.tenderNum = bjinfo.status==2?bjinfo.zbsl:'';
                            rowGys.zbjg = bjinfo.status==2?bjinfo.zbjg:'';  // 中标价格
                        }
                        if(bjinfo.isFq == '-999'){  // 是否放弃
                            rowGys['isFq'] = '-999'
                        }else{
                            rowGys['isFq'] = bjinfo.isFq?bjinfo.isFq == '是'?true:false:-1
                        }
                        if(index<1){    // 包含物料数据
                            curObj = {
                                ...rowObj,
                                ...{
                                    wzCode:good.commodityCode,
                                    qgdh:good.inquiryDetail.qgdh,    // 请购单号
                                    wzName:good.commodityName,
                                    wzModel:good.commodityModel,
                                    figueNumber:good.commodity.figueNumber,
                                    sspace:good.commoditySspace,
                                    xjnum:good.inquiryDetail.num,    // 去询价单上 商品的询价数量
                                    // paramPz:good.paramPz,
                                    unit:good.unit,
                                    xqDate:good.xqDate,
                                    // fixedPrice:good.fixedPrice,
                                    bcExplain:good.bcExplain,
                                    isXqYp:good.isXqYp,
                                    // isConcatTax:good.isConcatTax,
                                    src:good.src,
                                },
                                ...rowGys
                            };
                            curObj['rowNo'] = gindex+1;
                            curObj['masterRow'] = true;
                        }else{  // 不包含物料数据
                            curObj = {...rowObj,...rowGys};
                        }
                        curObj['id'] = `${good.id}_${gys.id}`;
                        tableList.push(curObj)
                    })
                }else{
                    let curObj = {
                        ...rowObj,
                        ...{
                            wzCode:good.commodityCode,
                            qgdh:good.inquiryDetail.qgdh,
                            wzName:good.commodityName,
                            wzModel:good.commodityModel,
                            figueNumber:good.commodity.figueNumber,
                            sspace:good.commoditySspace,
                            xjnum:good.inquiryDetail.num,
                            unit:good.unit,
                            xqDate:good.xqDate,
                            bcExplain:good.bcExplain,
                            isXqYp:good.isXqYp,
                        },
                    };
                    curObj['rowNo'] = gindex+1;
                    curObj['masterRow'] = true;
                    tableList.push(curObj)
                }

            })
            tableList.forEach((row,rowIndex)=>{
                row['index'] = rowIndex
            });
            callback(tableList)
        },
        // 保存 报价  isCheck 是否校验必填项  暂存不校验
        saveInfo(isCheck){
            let _this = this;
            let bjData = [];
            let errorText = '';
            let sameInfo = []
            this.tableData.forEach((item,index)=>{
                let obj = {
                    id:item.backId,                     // 物料行id
                    detailId:item.detailId,             //
                    price:item.price,                   // 单价
                    taxRate:item.taxRate,                   // 税率
                    isFq:item.isFq?'是':'否',           // 是否放弃
                    manufacture:item.manufacture,       // 制造厂商
                    ghZq:item.ghZq,                     // 供货周期
                    bjExplain:item.bjExplain,           // 报价说明
                    effectivePeriod:item.effectivePeriod,           // 报价有效期
                    bjwlmc:item.bjwlmc,           // 报价物料名称
                    bjgg:item.bjgg,           // 报价规格
                    bjxh:item.bjxh,           // 报价型号
                    bjth:item.bjth,           // 报价图号
                    num:item.num,           // 报价数量
                    minCgl:item.minCgl,                 // 最小采购量
                    remark:item.remark,                 // 特殊备注
                    gysSrc:item.gysSrc,                 // 供应商附件
                };
                // 询报价信息是否一致 处理
                let flag = true;
                let noSameArr = [];
                if(!item.isFq && isCheck){     // 未放弃的要校验是否必填
                    // 当报价数量等于或小于询价数量时，不准填写最小起订量
                    if(item.num && item.num <= item.xjnum && (item.minCgl || (item.minCgl==0 && item.minCgl+''))){
                        console.log(item.num <= item.xjnum)
                        console.log(item.minCgl+'')
                        errorText = `第${index+1}行，报价数量等于或小于询价数量时，不能填写最小起订量`
                    }
                    // 报价数量大于询价数量时，必须填写最小采购量，且保持一致
                    if(item.num && item.num > item.xjnum && item.num != item.minCgl){
                        errorText = `第${index+1}行，当报价数量大于询价数量时，必须填写最小采购量，且数量需保持一致！`
                    }
                    if(!errorText&&!item.price ){
                        errorText = `第${index+1}行含税单价不能为空`
                    }
                    if(!errorText&&!item.ghZq){
                        errorText = `第${index+1}行供货周期不能为空`
                    }
                    if(!errorText&&!item.effectivePeriod){
                        errorText = `第${index+1}行报价有效期不能为空`
                    }
               //     if(!errorText&&!item.taxRate){
                //        errorText = `第${index+1}行税率不能为空`
                  //  }
                    if(!errorText&&!item.manufacture){
                        errorText = `第${index+1}行运费模式不能为空`
                    }
                    if(item.figueNumber!=item.bjth){ // 图号
                        if(flag){flag = false}
                        noSameArr.push('报价图号')
                    }
                    if(item.wzName!=item.bjwlmc){ // 名称
                        if(flag){flag = false}
                        noSameArr.push('报价物料名称')
                    }
                    if(item.sspace!=item.bjgg){ // 规格
                        if(flag){flag = false}
                        noSameArr.push('报价规格')
                    }
                    if(item.wzModel!=item.bjxh){ // 型号
                        if(flag){flag = false}
                        noSameArr.push('报价型号')
                    }
                    if(item.xjnum!=item.num){ // 数量
                        if(flag){flag = false}
                        noSameArr.push('报价数量')
                    }
                }
                if(!flag){
                    sameInfo.push(`第${index+1}行，${noSameArr.join('\\')}不符`);
                }
                bjData.push(obj);
            });
            // console.log(bjData)
            if(errorText){
                this.$fail(errorText)
                return
            }
            if(sameInfo.length){
                _this.$confirm(sameInfo.join(';'), '提示', {
                    confirmButtonText: '继续保存',
                    cancelButtonText: '返回修改',
                    type: 'warning'
                }).then(() => {
                    updateBjList(bjData).then(({data:res})=>{
                        if(res.code == 0){
                            this.$success(`${isCheck?'保存':'暂存'}成功`);
                            this.openDialog = false;
                        }
                    })
                }).catch(() => {

                });
            }else{
                updateBjList(bjData).then(({data:res})=>{
                    if(res.code == 0){
                        this.$success(`${isCheck?'保存':'暂存'}成功`);
                        this.openDialog = false;
                    }
                })
            }

        },
        // 限制只能输入两位小数得数字
        fixedPriceChange(row,prop){
            let curVal = row[prop];
            curVal = curVal.replace(/(^\s*)|(\s*$)/g, "");
            const reg = /[^\d.]/g;
            // 只能是数字和小数点，不能是其他输入
            curVal = curVal.replace(reg, "");
            // 保证第一位只能是数字，不能是点
            curVal = curVal.replace(/^\./g, "");
            // 小数只能出现1位
            curVal = curVal
                .replace(".", "$#$")
                .replace(/\./g, "")
                .replace("$#$", ".");
            // 小数点后面保留2位
            curVal = curVal.replace( /^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
            row[prop] = curVal;
            // if(prop == 'price' || prop == 'taxRate'){   // 填写了含税单价和税率 计算 无税单价
            //     this.countExTaxPrice(row)
            // }
        },
        // 整数
        tenderNumChange(row,prop){
            let curVal = row[prop];
            if(curVal){
                curVal = curVal.replace(/[^\.\d]/g, '')
                curVal = curVal.replace('.', '')
            }
            row[prop] = curVal;
        },
        // 计算无税单价 保留两位小数
        countExTaxPrice(row){
        },
        // 计算无税金额 保留两位小数
        countExTaxAmount(row){
            this.tableData.forEach((item,index)=>{
                if(item.backId == row.backId){
                    let curP = '';
                    if(row.num && item.exTaxPrice){
                        curP = decimalUtil('mul',Number(row.num),Number(item.exTaxPrice),2)
                    }
                    this.$set(this.tableData[index],'exTaxAmount',curP)
                }
            })
        },
        // 计算无税金额 保留两位小数
        countExTaxMinAmount(row){
            this.tableData.forEach((item,index)=>{
                if(item.backId == row.backId){
                    let curP = '';
                    if(row.price && item.minCgl){
                        curP = decimalUtil('mul',Number(row.price),Number(item.minCgl),2)
                    }
                    this.$set(this.tableData[index],'minAmount',curP)
                }
            })
        },


        clickUpload(row){
            // console.log('点击行')
            // console.log(row)
            this.uploadRow = row;
        },
        handleAvatarSuccess(res, file) {
            if (res.code == 0) {
                this.$success(res.msg);
                let curRow = {...this.uploadRow};
                // console.log(this.uploadRow)
                if (curRow.gysSrc != "" && curRow.gysSrc  != undefined) {
                    //如果修改附件 则删除原来的附件
                    if (curRow.gysSrc  != res.data.url) {
                        this.delFile(curRow.gysSrc );
                    }
                }
                curRow.gysSrc = res.data.url;
                this.$set(this.tableData,curRow.index,curRow)
            }
        },
        beforeAvatarUpload(file) {
            //      let type = file.name.substring(file.name.lastIndexOf('.') + 1) //判断文件后缀
            const isLt2M = file.size / 1024 / 1024 <= 50;
            if (!isLt2M) {
                this.$fail('上传附件大小不能超过 50MB!');
            }
            return isLt2M;
        },
        // 确认定标
        saveTender(){
            let _this = this;
            let dbData = [];
            let error = '';
            let tenderNumObj = {};
            this.tableData.forEach((item)=>{
                let obj = {
                    id:item.backId,                     // 物料行id
                    orderId:item.orderId,          // 订单id
                    status:item.isTender?2:3,            // 2中标 3未中标
                    num:item.isTender&&item.tenderNum!=''?parseInt(item.tenderNum):0,     // 中标数量
                };
                if(!error){
                    if(item.isTender && (!item.tenderNum || item.tenderNum&&item.tenderNum>item.xjnum)){
                        error = `${item.gysName}中标${item.wzName}的中标数量有误，请检查`
                    }

                }
                dbData.push(obj)
            });
            if(error){
                this.$warn(error)
                return
            }
             _this.confirm({
                text: '是否确认定标？',
                tip: '提示',
                type: 'info',
                fn: function(param) {
                    dingbiaoOrder(param).then(({data:res})=>{
                        if(res.code == 0){
                            _this.$success('保存成功');
                            _this.$emit('callback',{type:'updateInfo'});
                            _this.openDialog = false;
                        }
                    })
                },
                data: dbData //参数对象 主要回调函数用
            });

        },
    },
    computed:{
        PAGESIZE:function(){
            return this.$store.getters['app/sizeInfo'];
        },
        makerInfo:function(){
            return this.$store.getters['app/makerInfo'];
        },
    },
    mounted(){
    },
}
</script>
<style rel="stylesheet/scss" lang="scss">
    .enquiry-detail-dislog{
        margin-top: 10px!important;
        margin-bottom: 10px!important;
        .gys-col{
            background: #ecf5ff;
        }
        .gys-name-col{
            background: #eee;
            color: #999;
        }
        .el-table--border::after {
            width: 1px;
            top: 0;
            right: 0;
            height: 100%;
        }
        .el-table--border .el-table__cell {
            border-right: 1px solid #82848a;
        }
        .el-table--mini .el-table__cell{
            padding: 2px 0;
        }
        .el-table--group, .el-table--border {
            border-top: 1px solid #82848a;
            border-left: 1px solid #82848a;
        }
        .el-table {
            .cell{
                padding-left: 5px;
                padding-right: 5px;
                .table-edit-input{
                    .el-input-group__append{
                        padding: 0 5px;
                    }
                }

            }
        }
    }
</style>
